import Hammer from 'hammerjs';
// Needed to import successfully
import svgPanZoom from 'svg-pan-zoom/dist/svg-pan-zoom.min';
import assign from 'lodash/assign';
import throttle from 'lodash/throttle';

export default function(seatMapEl, settings) {
    const eventsHandler = {
        haltEventListeners: ['touchstart', 'touchend', 'touchmove', 'touchleave', 'touchcancel'],
        init: function(options) {
            var instance = options.instance;
            var initialScale = 1;
            var pannedX = 0;
            var pannedY = 0;

            // Init Hammer
            // Listen only for pointer and touch events
            this.hammer = Hammer(options.svgElement, {
                inputClass: Hammer.SUPPORT_POINTER_EVENTS ? Hammer.PointerEventInput : Hammer.TouchInput
            });

            // Enable pinch
            this.hammer.get('pinch').set({
                enable: true
            });

            // Handle pan
            this.hammer.on('panstart panmove', function(ev) {
                // On pan start reset panned variables
                if (ev.type === 'panstart') {
                    pannedX = 0
                    pannedY = 0
                }

                // Pan only the difference
                instance.panBy({
                    x: ev.deltaX - pannedX,
                    y: ev.deltaY - pannedY
                });

                pannedX = ev.deltaX
                pannedY = ev.deltaY
            });

            // Handle pinch
            this.hammer.on('pinchstart pinchmove', function (ev) {
                // On pinch start remember initial zoom
                if (ev.type === 'pinchstart') {
                    initialScale = instance.getZoom()
                    instance.zoom(initialScale * ev.scale)
                }
                instance.zoom(initialScale * ev.scale)
            })

            // Prevent moving the page on some devices when panning over SVG
            options.svgElement.addEventListener('touchmove', function (e) {
                e.preventDefault();
            });
        },

        destroy: function() {
            this.hammer.destroy();
        }
    };

    /**
     * Initialise pan zoom
     * @see https://github.com/ariutta/svg-pan-zoom
     */
    let panZoom = svgPanZoom(seatMapEl, assign({
        zoomEnabled: true,
        customEventsHandler: eventsHandler,
        controlIconsEnabled: false,
        dblClickZoomEnabled: false,
        mouseWheelZoomEnabled: false,
        zoomScaleSensitivity: 1,
        center: true,
        fit: true
    }, settings));

    /**
     * Re-center on resize, throttle for performance
     */
    window.addEventListener('resize', throttle(function() {
        panZoom.resize();
    }), 100);

    return panZoom;
}



// WEBPACK FOOTER //
// ./src/javascripts/app/behaviours/panZoom.js